import { Badge, Button, Group, HoverCard, List, Select, Stack, Text, ThemeIcon, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useState } from "react";
import PoolsSelector from "../../../../../components/Selectors/PoolsSelector";
import ColumnEditor from "../../../../../layouts/Table/columns/ColumnEditor";
import CreatePool from "../../../../../layouts/Table/columns/CreatePool";
import { editBlacklist } from "../../../../../api/BlacklistAPI";
import { IconInfoCircle } from "@tabler/icons-react";
import PopOver from "../../../../../components/View/PopOver";

const BlacklistTypeEditor = ({ id, value, closePopover, apiRef }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    let data = new FormData(e.target);
    let actualValue = data.get("contains_match") === "true" ? true : false;

    setLoading(true);
    editBlacklist({
      id,
      contains_match: actualValue,
    })
      .then((response) => {
        closePopover();
        apiRef.current?.updateRows([{
          id,
          contains_match: actualValue,
        }]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack component={"form"} onSubmit={handleSubmit} gap={"xs"} w={180}>
      <Select
        data={
          [
            { label: "Exact", value: "false" },
            { label: "Contient", value: "true" },
          ]
        }
        defaultValue={value.toString()}
        name="contains_match"
      />
      <Group wrap="nowrap" justify="end">
        <Button
          onClick={closePopover}
          size="compact-sm"
          variant="subtle"
          disabled={loading}
          ml={"auto"}
        >
          {lang.components.closer.submit}
        </Button>
        <Button
          type="submit"
          loading={loading}
          size="compact-sm"
          color="tertiary.8"
        >
          {lang.contact_lists.edit.dialog.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export const blacklistTypeColumn = ({ apiRef }) => {
  const lang = useLanguage.getState().language;
  return {
    field: "contains_match",
    headerName: lang.emails_account.columns.type,
    width: 120,
    cellClassName: "hover-source",
    renderCell: (cell) => {
      return (
        <Group wrap="nowrap" w={"100%"}>

          <PopOver
            opener={(openFunction, ref, opened) => (
              <Badge
                color={cell.value ? "orange.8" : "green.7"}
                style={{ cursor: "pointer" }}
                ref={ref}
                onClick={(e) => {
                  e.stopPropagation()
                  openFunction()
                }}
                radius={"md"}
                className="scale-on-hover"
              >
                {/* {cell.value ? lang.blacklists.contains : lang.blacklists.exact} */}
                {cell.value ? lang.blacklists.type_contains : lang.blacklists.type_exact}
              </Badge>
            )}
            popoverChildren={(closePopover) =>
              <BlacklistTypeEditor
                id={cell.row.id}
                value={cell.value}
                closePopover={closePopover}
                apiRef={apiRef}
              />}
            elevation={3}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            transformOrigin={{ horizontal: "center", vertical: "top" }}
          />
        </Group>
      );
    },
    renderHeader: (params) => {
      return (
        <Group wrap="nowrap" w={"100%"} justify="space-between">
          {params.colDef.headerName}

          <HoverCard width={400} position="top">
            <HoverCard.Target>
              <ThemeIcon>
                <IconInfoCircle size={16} />
              </ThemeIcon>
            </HoverCard.Target>
            <HoverCard.Dropdown>
              <Text>
                Vous pouvez selectionner le mode d'exclusion de vos blacklists :
              </Text>
              <List>
                <List.Item>
                  <b>Exacte</b> : exclusion des mots clés au sens stricte du terme
                </List.Item>
                <List.Item>
                  <b>Contient</b> : exclusion de tous les contacts qui contiennent les mots clés à exclure
                </List.Item>
              </List>
            </HoverCard.Dropdown>
          </HoverCard>
        </Group>
      );
    }
  };
};
